const TYPES = {
  UI:{
    BUTTON: {
      REGULAR: 'regular',
      OUTLINED: 'outlined',
      GREEN: 'green'
    },
    INFO_SCREEN:{
      ACCOUNT_CREATED: 'account_created',
      EMAIL_VERIFICATION_PENDING: 'email_verification_pending',
      SUCCESS: 'success',
      ERROR: 'error',
      WARN: 'warn',
      SUBSCRIPTION_DONE: 'sub_done'
    },
    DATAVIEW:{
      LIST: 'list',
      STREAK: 'streak',
      PROGRESS: 'progress'
    },
    NOTIFICATION_STATUS: {
      GRANTED: 'granted',
      DENIED: 'denied',
      DEFAULT: 'default'
    }
  },
  DATABASE: {
    TABLES: {
      USER: 'users',
      FEELINGS: 'feelings',
      USERS_FEELINGS: 'users_feelings',
      BODY_REACTIONS: 'body_reactions',
      USERS_BODY_REACTIONS: 'users_body_reactions',
      LOGS: "logs",
      PSYCHOLOGISTS: "psychologists",
      LOGS_SHARED: "logs_shared",
      USERS_PSYCHOLOGISTS: "users_psychologists",
      APPOINTMENTS: "appointments",
      GOOGLE_ACCOUNTS: "google_accounts",
      PUSH_SUBSCRIPTIONS: "push_subscriptions",
      INVITES: "invites"
    },
    PAGINATION:{
      LOGS_PAGE_SIZE : 30,
    },
    PROFILES: {
      ADMIN: {code: 'ADMIN', label: 'profiles.admin', key: 3},
      PSYCHOLOGIST: {code: 'PSYCHOLOGIST', label: 'profiles.psychologist', key: 2},
      USER: {code: 'USER', label: 'profiles.user', key: 1}
    },
    NOTIFICATION:{
      APPOINTMENT_CREATED: { title: 'push_notification.appointment_created.title', body: 'push_notification.appointment_created.body'},
      MOOD_REMINDER: { title: 'push_notification.mood_reminder.title', body: 'push_notification.mood_reminder.body'},
      CONNECTION_REQUEST: { title: 'push_notification.connection_request.title', body: 'push_notification.connection_request.body'},
      CONNECTION_APPROVED: { title: 'push_notification.connection_approved.title', body: 'push_notification.connection_approved.body'},
      CONNECTION_REJECTED: { title: 'push_notification.connection_rejected.title', body: 'push_notification.connection_rejected.body'},
      INVITE_ACCEPTED: { title: 'push_notification.invite_accepted.title', body: 'push_notification.invite_accepted.body'},
    },
    STATUS: {
      ACTIVE: {code: 'ACTIVE', label: 'status.active'},
      WAITING_VALIDATION: {code: 'WAITING_VALIDATION', label: 'status.waiting_validation'},
      DEACTIVATED: {code: 'DEACTIVATED', label: 'status.deactivated'},
      WAITING_CONFIRMATION: {code: 'WAITING_CONFIRMATION', label: 'status.waiting_confirmation'},
      CONFIRMED: {code: 'CONFIRMED', label: 'status.confirmed'},
      ACCEPTED: {code: 'ACCEPTED', label: 'status.accepted'},
      REJECTED: {code: 'REJECTED', label: 'status.rejected'},
      PENDING: {code: 'PENDING', label: 'status.pending'}
    },
    STRIPE_STATUS: {
      incomplete: {code: 'incomplete', label: 'stripe_status.incomplete'}, 
      incomplete_expired: {code: 'incomplete_expired', label: 'stripe_status.incomplete_expired'},  
      trialing: {code: 'trialing', label: 'stripe_status.trialing'}, 
      active: {code: 'active', label: 'stripe_status.active'}, 
      past_due: {code: 'past_due', label: 'stripe_status.past_due'}, 
      canceled: {code: 'canceled', label: 'stripe_status.canceled'}, 
      unpaid: {code: 'unpaid', label: 'stripe_status.unpaid'}, 
      paused: {code: 'paused', label: 'stripe_status.paused'}
    },
    PLANS: {
      STARTER: { code: 'STARTER', label: 'plans.starter' },
      PROFESSIONAL: { code: 'PROFESSIONAL', label: 'plans.professional', price_id: 'price_1SSETVRARhnCg7U3lUl2E8a7' },
      PROFESSIONAL_FREE: { code: 'PROFESSIONAL', label: 'plans.professional', price_id: 'price_1SVgO8RARhnCg7U3bGyMoIXx' }
    },
    CURRENCY: [
      {code: 'EUR', symbol: '€'},
      {code: 'BRL', symbol: 'R$'},
      {code: 'USD', symbol: '$'}
    ],
    DURATION: [
      {code: 60, label: 'labels.60_minutes'},
      {code: 50, label: 'labels.50_minutes'},
      {code: 45, label: 'labels.45_minutes'},
      {code: 30, label: 'labels.30_minutes'}
    ],
    COUNTRY_GROUPS: [
      {
        name: "country-group.popular",
        countries: [
          { iso: "BR", name: "countries.brazil", dial_code: "+55" },
          { iso: "FR", name: "countries.france", dial_code: "+33" },
          { iso: "PT", name: "countries.portugal", dial_code: "+351" },
          { iso: "ES", name: "countries.spain", dial_code: "+34" },
          { iso: "GB", name: "countries.united_kingdom", dial_code: "+44" },
          { iso: "US", name: "countries.united_states", dial_code: "+1" }
        ]
      },
      {
        name: "country-group.all",
        countries: [
          { iso: "AF", name: "countries.afghanistan", dial_code: "+93" },
          { iso: "AL", name: "countries.albania", dial_code: "+355" },
          { iso: "DZ", name: "countries.algeria", dial_code: "+213" },
          { iso: "AS", name: "countries.american_samoa", dial_code: "+1-684" },
          { iso: "AD", name: "countries.andorra", dial_code: "+376" },
          { iso: "AO", name: "countries.angola", dial_code: "+244" },
          { iso: "AI", name: "countries.anguilla", dial_code: "+1-264" },
          { iso: "AQ", name: "countries.antarctica", dial_code: "+672" },
          { iso: "AG", name: "countries.antigua_barbuda", dial_code: "+1-268" },
          { iso: "AR", name: "countries.argentina", dial_code: "+54" },
          { iso: "AM", name: "countries.armenia", dial_code: "+374" },
          { iso: "AW", name: "countries.aruba", dial_code: "+297" },
          { iso: "AU", name: "countries.australia", dial_code: "+61" },
          { iso: "AT", name: "countries.austria", dial_code: "+43" },
          { iso: "AZ", name: "countries.azerbaijan", dial_code: "+994" },
          { iso: "BS", name: "countries.bahamas", dial_code: "+1-242" },
          { iso: "BH", name: "countries.bahrain", dial_code: "+973" },
          { iso: "BD", name: "countries.bangladesh", dial_code: "+880" },
          { iso: "BB", name: "countries.barbados", dial_code: "+1-246" },
          { iso: "BY", name: "countries.belarus", dial_code: "+375" },
          { iso: "BE", name: "countries.belgium", dial_code: "+32" },
          { iso: "BZ", name: "countries.belize", dial_code: "+501" },
          { iso: "BJ", name: "countries.benin", dial_code: "+229" },
          { iso: "BM", name: "countries.bermuda", dial_code: "+1-441" },
          { iso: "BT", name: "countries.bhutan", dial_code: "+975" },
          { iso: "BO", name: "countries.bolivia", dial_code: "+591" },
          { iso: "BA", name: "countries.bosnia_herzegovina", dial_code: "+387" },
          { iso: "BW", name: "countries.botswana", dial_code: "+267" },
          { iso: "BR", name: "countries.brazil", dial_code: "+55" },
          { iso: "BN", name: "countries.brunei", dial_code: "+673" },
          { iso: "BG", name: "countries.bulgaria", dial_code: "+359" },
          { iso: "BF", name: "countries.burkina_faso", dial_code: "+226" },
          { iso: "BI", name: "countries.burundi", dial_code: "+257" },
          { iso: "CV", name: "countries.cabo_verde", dial_code: "+238" },
          { iso: "KH", name: "countries.cambodia", dial_code: "+855" },
          { iso: "CM", name: "countries.cameroon", dial_code: "+237" },
          { iso: "CA", name: "countries.canada", dial_code: "+1" },
          { iso: "CF", name: "countries.central_african_republic", dial_code: "+236" },
          { iso: "TD", name: "countries.chad", dial_code: "+235" },
          { iso: "CL", name: "countries.chile", dial_code: "+56" },
          { iso: "CN", name: "countries.china", dial_code: "+86" },
          { iso: "CO", name: "countries.colombia", dial_code: "+57" },
          { iso: "KM", name: "countries.comoros", dial_code: "+269" },
          { iso: "CD", name: "countries.congo_drc", dial_code: "+243" },
          { iso: "CG", name: "countries.congo", dial_code: "+242" },
          { iso: "CR", name: "countries.costa_rica", dial_code: "+506" },
          { iso: "HR", name: "countries.croatia", dial_code: "+385" },
          { iso: "CU", name: "countries.cuba", dial_code: "+53" },
          { iso: "CY", name: "countries.cyprus", dial_code: "+357" },
          { iso: "CZ", name: "countries.czech_republic", dial_code: "+420" },
          { iso: "DK", name: "countries.denmark", dial_code: "+45" },
          { iso: "DJ", name: "countries.djibouti", dial_code: "+253" },
          { iso: "DM", name: "countries.dominica", dial_code: "+1-767" },
          { iso: "DO", name: "countries.dominican_republic", dial_code: "+1-809" },
          { iso: "EC", name: "countries.ecuador", dial_code: "+593" },
          { iso: "EG", name: "countries.egypt", dial_code: "+20" },
          { iso: "SV", name: "countries.el_salvador", dial_code: "+503" },
          { iso: "EE", name: "countries.estonia", dial_code: "+372" },
          { iso: "SZ", name: "countries.eswatini", dial_code: "+268" },
          { iso: "ET", name: "countries.ethiopia", dial_code: "+251" },
          { iso: "FJ", name: "countries.fiji", dial_code: "+679" },
          { iso: "FI", name: "countries.finland", dial_code: "+358" },
          { iso: "FR", name: "countries.france", dial_code: "+33" },
          { iso: "GA", name: "countries.gabon", dial_code: "+241" },
          { iso: "GM", name: "countries.gambia", dial_code: "+220" },
          { iso: "GE", name: "countries.georgia", dial_code: "+995" },
          { iso: "DE", name: "countries.germany", dial_code: "+49" },
          { iso: "GH", name: "countries.ghana", dial_code: "+233" },
          { iso: "GR", name: "countries.greece", dial_code: "+30" },
          { iso: "GL", name: "countries.greenland", dial_code: "+299" },
          { iso: "GD", name: "countries.grenada", dial_code: "+1-473" },
          { iso: "GT", name: "countries.guatemala", dial_code: "+502" },
          { iso: "GN", name: "countries.guinea", dial_code: "+224" },
          { iso: "GW", name: "countries.guinea_bissau", dial_code: "+245" },
          { iso: "GY", name: "countries.guyana", dial_code: "+592" },
          { iso: "HT", name: "countries.haiti", dial_code: "+509" },
          { iso: "HN", name: "countries.honduras", dial_code: "+504" },
          { iso: "HK", name: "countries.hong_kong", dial_code: "+852" },
          { iso: "HU", name: "countries.hungary", dial_code: "+36" },
          { iso: "IS", name: "countries.iceland", dial_code: "+354" },
          { iso: "IN", name: "countries.india", dial_code: "+91" },
          { iso: "ID", name: "countries.indonesia", dial_code: "+62" },
          { iso: "IR", name: "countries.iran", dial_code: "+98" },
          { iso: "IQ", name: "countries.iraq", dial_code: "+964" },
          { iso: "IE", name: "countries.ireland", dial_code: "+353" },
          { iso: "IL", name: "countries.israel", dial_code: "+972" },
          { iso: "IT", name: "countries.italy", dial_code: "+39" },
          { iso: "JM", name: "countries.jamaica", dial_code: "+1-876" },
          { iso: "JP", name: "countries.japan", dial_code: "+81" },
          { iso: "JO", name: "countries.jordan", dial_code: "+962" },
          { iso: "KZ", name: "countries.kazakhstan", dial_code: "+7" },
          { iso: "KE", name: "countries.kenya", dial_code: "+254" },
          { iso: "KI", name: "countries.kiribati", dial_code: "+686" },
          { iso: "KW", name: "countries.kuwait", dial_code: "+965" },
          { iso: "KG", name: "countries.kyrgyzstan", dial_code: "+996" },
          { iso: "LA", name: "countries.laos", dial_code: "+856" },
          { iso: "LV", name: "countries.latvia", dial_code: "+371" },
          { iso: "LB", name: "countries.lebanon", dial_code: "+961" },
          { iso: "LS", name: "countries.lesotho", dial_code: "+266" },
          { iso: "LR", name: "countries.liberia", dial_code: "+231" },
          { iso: "LY", name: "countries.libya", dial_code: "+218" },
          { iso: "LI", name: "countries.liechtenstein", dial_code: "+423" },
          { iso: "LT", name: "countries.lithuania", dial_code: "+370" },
          { iso: "LU", name: "countries.luxembourg", dial_code: "+352" },
          { iso: "MO", name: "countries.macau", dial_code: "+853" },
          { iso: "MG", name: "countries.madagascar", dial_code: "+261" },
          { iso: "MW", name: "countries.malawi", dial_code: "+265" },
          { iso: "MY", name: "countries.malaysia", dial_code: "+60" },
          { iso: "MV", name: "countries.maldives", dial_code: "+960" },
          { iso: "ML", name: "countries.mali", dial_code: "+223" },
          { iso: "MT", name: "countries.malta", dial_code: "+356" },
          { iso: "MH", name: "countries.marshall_islands", dial_code: "+692" },
          { iso: "MR", name: "countries.mauritania", dial_code: "+222" },
          { iso: "MU", name: "countries.mauritius", dial_code: "+230" },
          { iso: "MX", name: "countries.mexico", dial_code: "+52" },
          { iso: "FM", name: "countries.micronesia", dial_code: "+691" },
          { iso: "MD", name: "countries.moldova", dial_code: "+373" },
          { iso: "MC", name: "countries.monaco", dial_code: "+377" },
          { iso: "MN", name: "countries.mongolia", dial_code: "+976" },
          { iso: "ME", name: "countries.montenegro", dial_code: "+382" },
          { iso: "MA", name: "countries.morocco", dial_code: "+212" },
          { iso: "MZ", name: "countries.mozambique", dial_code: "+258" },
          { iso: "MM", name: "countries.myanmar", dial_code: "+95" },
          { iso: "NA", name: "countries.namibia", dial_code: "+264" },
          { iso: "NR", name: "countries.nauru", dial_code: "+674" },
          { iso: "NP", name: "countries.nepal", dial_code: "+977" },
          { iso: "NL", name: "countries.netherlands", dial_code: "+31" },
          { iso: "NZ", name: "countries.new_zealand", dial_code: "+64" },
          { iso: "NI", name: "countries.nicaragua", dial_code: "+505" },
          { iso: "NE", name: "countries.niger", dial_code: "+227" },
          { iso: "NG", name: "countries.nigeria", dial_code: "+234" },
          { iso: "KP", name: "countries.north_korea", dial_code: "+850" },
          { iso: "MK", name: "countries.north_macedonia", dial_code: "+389" },
          { iso: "NO", name: "countries.norway", dial_code: "+47" },
          { iso: "OM", name: "countries.oman", dial_code: "+968" },
          { iso: "PK", name: "countries.pakistan", dial_code: "+92" },
          { iso: "PW", name: "countries.palau", dial_code: "+680" },
          { iso: "PA", name: "countries.panama", dial_code: "+507" },
          { iso: "PG", name: "countries.papua_new_guinea", dial_code: "+675" },
          { iso: "PY", name: "countries.paraguay", dial_code: "+595" },
          { iso: "PE", name: "countries.peru", dial_code: "+51" },
          { iso: "PH", name: "countries.philippines", dial_code: "+63" },
          { iso: "PL", name: "countries.poland", dial_code: "+48" },
          { iso: "PT", name: "countries.portugal", dial_code: "+351" },
          { iso: "PR", name: "countries.puerto_rico", dial_code: "+1-787" },
          { iso: "QA", name: "countries.qatar", dial_code: "+974" },
          { iso: "RO", name: "countries.romania", dial_code: "+40" },
          { iso: "RU", name: "countries.russia", dial_code: "+7" },
          { iso: "RW", name: "countries.rwanda", dial_code: "+250" },
          { iso: "KN", name: "countries.saint_kitts_nevis", dial_code: "+1-869" },
          { iso: "LC", name: "countries.saint_lucia", dial_code: "+1-758" },
          { iso: "VC", name: "countries.saint_vincent_grenadines", dial_code: "+1-784" },
          { iso: "WS", name: "countries.samoa", dial_code: "+685" },
          { iso: "SM", name: "countries.san_marino", dial_code: "+378" },
          { iso: "SA", name: "countries.saudi_arabia", dial_code: "+966" },
          { iso: "SN", name: "countries.senegal", dial_code: "+221" },
          { iso: "RS", name: "countries.serbia", dial_code: "+381" },
          { iso: "SC", name: "countries.seychelles", dial_code: "+248" },
          { iso: "SL", name: "countries.sierra_leone", dial_code: "+232" },
          { iso: "SG", name: "countries.singapore", dial_code: "+65" },
          { iso: "SK", name: "countries.slovakia", dial_code: "+421" },
          { iso: "SI", name: "countries.slovenia", dial_code: "+386" },
          { iso: "SO", name: "countries.somalia", dial_code: "+252" },
          { iso: "ZA", name: "countries.south_africa", dial_code: "+27" },
          { iso: "KR", name: "countries.south_korea", dial_code: "+82" },
          { iso: "ES", name: "countries.spain", dial_code: "+34" },
          { iso: "LK", name: "countries.sri_lanka", dial_code: "+94" },
          { iso: "SD", name: "countries.sudan", dial_code: "+249" },
          { iso: "SR", name: "countries.suriname", dial_code: "+597" },
          { iso: "SE", name: "countries.sweden", dial_code: "+46" },
          { iso: "CH", name: "countries.switzerland", dial_code: "+41" },
          { iso: "SY", name: "countries.syria", dial_code: "+963" },
          { iso: "TW", name: "countries.taiwan", dial_code: "+886" },
          { iso: "TJ", name: "countries.tajikistan", dial_code: "+992" },
          { iso: "TZ", name: "countries.tanzania", dial_code: "+255" },
          { iso: "TH", name: "countries.thailand", dial_code: "+66" },
          { iso: "TL", name: "countries.timor_leste", dial_code: "+670" },
          { iso: "TG", name: "countries.togo", dial_code: "+228" },
          { iso: "TO", name: "countries.tonga", dial_code: "+676" },
          { iso: "TT", name: "countries.trinidad_tobago", dial_code: "+1-868" },
          { iso: "TN", name: "countries.tunisia", dial_code: "+216" },
          { iso: "TR", name: "countries.turkey", dial_code: "+90" },
          { iso: "TM", name: "countries.turkmenistan", dial_code: "+993" },
          { iso: "UG", name: "countries.uganda", dial_code: "+256" },
          { iso: "UA", name: "countries.ukraine", dial_code: "+380" },
          { iso: "AE", name: "countries.united_arab_emirates", dial_code: "+971" },
          { iso: "GB", name: "countries.united_kingdom", dial_code: "+44" },
          { iso: "US", name: "countries.united_states", dial_code: "+1" },
          { iso: "UY", name: "countries.uruguay", dial_code: "+598" },
          { iso: "UZ", name: "countries.uzbekistan", dial_code: "+998" },
          { iso: "VU", name: "countries.vanuatu", dial_code: "+678" },
          { iso: "VA", name: "countries.vatican_city", dial_code: "+379" },
          { iso: "VE", name: "countries.venezuela", dial_code: "+58" },
          { iso: "VN", name: "countries.vietnam", dial_code: "+84" },
          { iso: "YE", name: "countries.yemen", dial_code: "+967" },
          { iso: "ZM", name: "countries.zambia", dial_code: "+260" },
          { iso: "ZW", name: "countries.zimbabwe", dial_code: "+263" }
        ]
      }
    ]
  },
  LANGUAGES: [
    { code: 'pt', locale: 'pt-BR', name: 'Português', flag: 'assets/flags/pt.png' },
    { code: 'en', locale: 'en', name: 'English',   flag: 'assets/flags/en.png' }
  ],
  APPLICATION:{
    MOODS: [
      {
        label: 'moods.super_positive',
        class: 'super-positive',
        image: '/imgs/super-positive.png'
      },
      {
        label: 'moods.positive',
        class: 'positive',
        image: '/imgs/positive.png'
      },
      {
        label: 'moods.neutral',
        class: 'neutral',
        image: '/imgs/neutral.png'
      },
      {
        label: 'moods.negative',
        class: 'negative',
        image: '/imgs/negative.png'
      },
      {
        label: 'moods.super_negative',
        class: 'super-negative',
        image: '/imgs/super-negative.png'
      },
    ],
    FEELINGS: [
      {
        label: 'feelings.super_positive',
        selected: false,
        provider: 'system'
      },
      {
        label: 'feelings.super_positive',
        selected: false,
        provider: 'system'
      },
      {
        label: 'feelings.super_positive',
        selected: false,
        provider: 'system'
      },
      {
        label: 'feelings.super_positive',
        selected: false,
        provider: 'system'
      },
      {
        label: 'feelings.super_positive',
        selected: false,
        provider: 'system'
      },
    ],
    COUNTRIES:[
      { name: 'countries.brazil', code: 'BR'},
      { name: 'countries.portugal', code: 'PT'},
      { name: 'countries.united_states', code: 'US'},
      { name: 'countries.united_kingdom', code: 'UK'},
      { name: 'countries.canada', code: 'CA'},
      { name: 'countries.australia', code: 'AU'}
    ],
    EMAILS_TYPES:{
      PROFILE_APPROVED: 'approved',
      PROFILE_REJECTED: 'rejected',
      CONNECTION_APPROVED: 'connection-approved',
      CONNECTION_REJECTED: 'connection-rejected'
    },
    HOLIDAYS: [
      { date: '2026-01-01', name: 'holidays.new_year' },
      { date: '2025-05-01', name: 'holidays.labor_day' },
      { date: '2025-12-25', name: 'holidays.christmas' }
    ]
  }
};

export default TYPES;
